import React from 'react'
import { DefaultDataTable } from '../../../components/dataTable/DefaultDataTable'

export const MarcadorList = (props) => <DefaultDataTable data={props} />
